import {FC} from 'react';
import SvgIcon, {SvgIconProps} from '@mui/material/SvgIcon';

export const WordIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon
        {...props}
        arial-label='Word File'
        role='img'
        viewBox='-3 -2 22 24'
    >
        <path
            d='M2 0C.9 0 .01.9.01 2L0 18c0 1.1.89 2 1.99 2H14c1.1 0 2-.9 2-2V6l-6-6H2zm7 7V1.5L14.5 7H9zm3.235 13h-2.34L8.08 12.71h-.03L6.265 20H3.88L1.045 9.29H3.4l1.695 7.29h.03l1.86-7.29H9.19l1.83 7.38h.03l1.755-7.38h2.31L12.235 20z'
            fillRule='nonzero'
        />
    </SvgIcon>
);
